import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import logo from '../../assets/logo-danes.png';

const CategorySelectionScreen = () => {
    const { categories, settings } = useAppContext();
    const navigate = useNavigate();

    const handleCategoryClick = (categoryId) => {
        navigate(`/products/${categoryId}`);
    };

    const handleShowAll = () => {
        navigate('/products/all');
    };

    const getCategoryIcon = (categoryName) => {
        const name = categoryName.toLowerCase();

        if (name.includes('café y chocolate') || name.includes('chocolate')) {
            return (
                <svg viewBox="0 0 64 64" fill="none" className="w-24 h-24">
                    <path d="M32 8c-8 0-14 4-14 8v4c0 4 6 8 14 8s14-4 14-8v-4c0-4-6-8-14-8z" fill="currentColor" opacity="0.3" />
                    <ellipse cx="32" cy="16" rx="14" ry="4" fill="currentColor" />
                    <path d="M18 16v24c0 4 6 8 14 8s14-4 14-8V16" stroke="currentColor" strokeWidth="3" fill="none" />
                    <path d="M46 24c4 0 8 2 8 6s-4 6-8 6" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" />
                </svg>
            );
        } else if (name.includes('café')) {
            return (
                <svg viewBox="0 0 64 64" fill="none" className="w-24 h-24">
                    <path d="M16 20h32v20c0 6-4 10-10 10h-12c-6 0-10-4-10-10V20z" fill="currentColor" opacity="0.3" />
                    <rect x="16" y="20" width="32" height="24" rx="4" stroke="currentColor" strokeWidth="3" fill="none" />
                    <path d="M48 28h4c3 0 6 2 6 5s-3 5-6 5h-4" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                    <path d="M22 12c0-2 1-4 3-4m5 4c0-2 1-4 3-4m5 4c0-2 1-4 3-4" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                    <path d="M20 50h24" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                </svg>
            );
        } else if (name.includes('marraqueta')) {
            return (
                <svg viewBox="0 0 64 64" fill="none" className="w-24 h-24">
                    <ellipse cx="32" cy="32" rx="22" ry="14" fill="currentColor" opacity="0.3" />
                    <ellipse cx="32" cy="32" rx="22" ry="14" stroke="currentColor" strokeWidth="2.5" />
                    <line x1="32" y1="18" x2="32" y2="46" stroke="currentColor" strokeWidth="2.5" />
                    <path d="M20 28c3-2 7-3 12-3s9 1 12 3" stroke="currentColor" strokeWidth="2" opacity="0.5" />
                    <path d="M20 36c3 2 7 3 12 3s9-1 12-3" stroke="currentColor" strokeWidth="2" opacity="0.5" />
                </svg>
            );
        } else if (name.includes('completo')) {
            return (
                <svg viewBox="0 0 64 64" fill="none" className="w-24 h-24">
                    <ellipse cx="32" cy="35" rx="20" ry="8" fill="currentColor" opacity="0.3" />
                    <path d="M14 28c0-3 4-5 8-5h20c4 0 8 2 8 5v2H14v-2z" fill="currentColor" opacity="0.5" />
                    <rect x="14" y="30" width="36" height="3" fill="#FF6347" />
                    <rect x="14" y="33" width="36" height="3" fill="#90EE90" />
                    <path d="M14 36h36c0 4-4 7-8 7H22c-4 0-8-3-8-7z" fill="currentColor" opacity="0.3" />
                    <path d="M14 28c0-3 4-5 8-5h20c4 0 8 2 8 5" stroke="currentColor" strokeWidth="2.5" />
                    <path d="M14 36c0 4 4 7 8 7h20c4 0 8-3 8-7" stroke="currentColor" strokeWidth="2.5" />
                </svg>
            );
        } else if (name.includes('croissant')) {
            return (
                <svg viewBox="0 0 64 64" fill="none" className="w-24 h-24">
                    <path d="M12 32c0-8 4-12 8-12s6 2 8 6c2-4 4-6 8-6s8 4 8 12c0 6-3 10-7 12H19c-4-2-7-6-7-12z" fill="currentColor" opacity="0.3" />
                    <path d="M20 20c4 0 6 3 8 7m8-7c4 0 6 3 8 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                    <path d="M12 34c2 6 6 10 10 10h20c4 0 8-4 10-10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                    <path d="M18 28c2 2 4 4 6 5m16-5c2 2 4 4 6 5" stroke="currentColor" strokeWidth="2" opacity="0.5" />
                </svg>
            );
        } else if (name.includes('bebida') || name.includes('frías')) {
            return (
                <svg viewBox="0 0 64 64" fill="none" className="w-24 h-24">
                    <rect x="18" y="12" width="28" height="40" rx="3" fill="currentColor" opacity="0.3" />
                    <rect x="18" y="12" width="28" height="40" rx="3" stroke="currentColor" strokeWidth="2.5" />
                    <path d="M18 22h28" stroke="currentColor" strokeWidth="2.5" />
                    <rect x="22" y="26" width="4" height="8" rx="1" fill="white" opacity="0.6" />
                    <rect x="30" y="28" width="4" height="6" rx="1" fill="white" opacity="0.6" />
                    <rect x="38" y="26" width="4" height="9" rx="1" fill="white" opacity="0.6" />
                    <circle cx="26" cy="40" r="2" fill="white" opacity="0.4" />
                    <circle cx="36" cy="42" r="2" fill="white" opacity="0.4" />
                    <path d="M23 8h18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                </svg>
            );
        } else if (name.includes('sandwich')) {
            return (
                <svg viewBox="0 0 64 64" fill="none" className="w-24 h-24">
                    <path d="M12 22c0-2 2-4 4-4h32c2 0 4 2 4 4v4H12v-4z" fill="#D2691E" />
                    <rect x="12" y="26" width="40" height="3" fill="#90EE90" />
                    <rect x="12" y="29" width="40" height="4" fill="#FF6347" />
                    <rect x="12" y="33" width="40" height="3" fill="#FFE4B5" />
                    <path d="M12 36h40v4c0 2-2 4-4 4H16c-2 0-4-2-4-4v-4z" fill="#D2691E" />
                    <path d="M12 22c0-2 2-4 4-4h32c2 0 4 2 4 4M12 40c0 2 2 4 4 4h32c2 0 4-2 4-4" stroke="currentColor" strokeWidth="2.5" />
                </svg>
            );
        } else if (name.includes('ciabatta')) {
            return (
                <svg viewBox="0 0 64 64" fill="none" className="w-24 h-24">
                    <ellipse cx="32" cy="32" rx="24" ry="12" fill="currentColor" opacity="0.3" />
                    <ellipse cx="32" cy="32" rx="24" ry="12" stroke="currentColor" strokeWidth="2.5" />
                    <circle cx="20" cy="28" r="2" fill="currentColor" opacity="0.5" />
                    <circle cx="28" cy="26" r="2" fill="currentColor" opacity="0.5" />
                    <circle cx="36" cy="27" r="2" fill="currentColor" opacity="0.5" />
                    <circle cx="44" cy="28" r="2" fill="currentColor" opacity="0.5" />
                    <circle cx="24" cy="34" r="1.5" fill="currentColor" opacity="0.5" />
                    <circle cx="32" cy="36" r="1.5" fill="currentColor" opacity="0.5" />
                    <circle cx="40" cy="34" r="1.5" fill="currentColor" opacity="0.5" />
                </svg>
            );
        }

        return (
            <svg viewBox="0 0 64 64" fill="none" className="w-24 h-24">
                <rect x="12" y="20" width="40" height="32" rx="4" stroke="currentColor" strokeWidth="2.5" />
                <path d="M20 12v8m24-8v8" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
        );
    };

    const getCategoryColor = (categoryName) => {
        const name = categoryName.toLowerCase();

        if (name.includes('café y chocolate')) {
            return { bg: 'linear-gradient(135deg, #6F4E37 0%, #8B4513 100%)', text: 'white' };
        } else if (name.includes('café')) {
            return { bg: 'linear-gradient(135deg, #A0522D 0%, #8B7355 100%)', text: 'white' };
        } else if (name.includes('marraqueta')) {
            return { bg: 'linear-gradient(135deg, #F5DEB3 0%, #DEB887 100%)', text: '#4A4A4A' };
        } else if (name.includes('completo')) {
            return { bg: 'linear-gradient(135deg, #FF6B6B 0%, #FF8E53 100%)', text: 'white' };
        } else if (name.includes('croissant')) {
            return { bg: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)', text: '#4A4A4A' };
        } else if (name.includes('bebida')) {
            return { bg: 'linear-gradient(135deg, #4ECDC4 0%, #44A08D 100%)', text: 'white' };
        } else if (name.includes('sandwich')) {
            return { bg: 'linear-gradient(135deg, #95E1D3 0%, #80CBC4 100%)', text: '#4A4A4A' };
        } else if (name.includes('ciabatta')) {
            return { bg: 'linear-gradient(135deg, #E8C5A5 0%, #D4A574 100%)', text: '#4A4A4A' };
        }

        return { bg: 'linear-gradient(135deg, #008751 0%, #00a862 100%)', text: 'white' };
    };

    const renderCategoryCard = (category, index) => {
        const colors = getCategoryColor(category.name);
        return (
            <button
                key={category.id}
                onClick={() => handleCategoryClick(category.id)}
                className="group relative rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:scale-105 overflow-hidden animate-slide-up"
                style={{
                    minHeight: '320px',
                    animationDelay: `${index * 0.1}s`,
                    background: colors.bg
                }}
            >
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />

                <div className="relative h-full p-6 flex flex-col items-center justify-center text-center">
                    <div className="mb-4 flex items-center justify-center transform group-hover:scale-110 transition-all duration-500" style={{ color: colors.text }}>
                        {getCategoryIcon(category.name)}
                    </div>

                    <h2 className="text-3xl font-bold leading-tight px-2" style={{ color: colors.text }}>
                        {category.name}
                    </h2>

                    <div className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <span className="text-lg font-medium" style={{ color: colors.text }}>
                            Ver productos →
                        </span>
                    </div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/50 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />
            </button>
        );
    };

    const firstRowCategories = categories.slice(0, 4);
    const secondRowCategories = categories.slice(4, 8);

    return (
        <div className="h-screen flex flex-col" style={{ backgroundColor: settings.box_color }}>
            <div
                className="py-8 shadow-xl relative overflow-hidden"
                style={{ backgroundColor: settings.card_color }}
            >
                <div className="relative z-10 flex flex-col items-center">
                    <img
                        src={logo}
                        alt="D"
                        className="h-20 w-auto mb-3 animate-fade-in"
                    />
                </div>
            </div>

            <div className="flex-1 overflow-auto flex items-center">
                <div className="max-w-[1800px] mx-auto px-6 w-full">
                    {categories && categories.length > 0 ? (
                        <div className="flex flex-col gap-20">
                            <div>
                                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                                    {firstRowCategories.map((category, index) =>
                                        renderCategoryCard(category, index)
                                    )}
                                </div>
                            </div>

                            <div>
                                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                                    {secondRowCategories.map((category, index) =>
                                        renderCategoryCard(category, index + 4)
                                    )}
                                </div>
                            </div>

                            <div className="flex justify-center pt-4">
                                <button
                                    onClick={handleShowAll}
                                    className="group relative px-16 py-5 text-2xl font-bold text-white rounded-2xl shadow-2xl transition-all duration-300 transform hover:scale-105 overflow-hidden"
                                    style={{ backgroundColor: settings.button_color }}
                                >
                                    <span className="relative z-10">Ver Todos los Productos</span>
                                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent transform -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-20">
                            <svg className="w-24 h-24 mx-auto text-gray-300 mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                            </svg>
                            <p className="text-3xl text-gray-400 font-medium">No hay categorías disponibles</p>
                        </div>
                    )}
                </div>
            </div>

            <style jsx>{`
                @keyframes fade-in {
                    from {
                        opacity: 0;
                        transform: translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes slide-up {
                    from {
                        opacity: 0;
                        transform: translateY(40px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .animate-fade-in {
                    animation: fade-in 0.8s ease-out;
                }

                .animate-fade-in-delay {
                    animation: fade-in 0.8s ease-out 0.2s both;
                }

                .animate-slide-up {
                    animation: slide-up 0.6s ease-out both;
                }
            `}</style>
        </div>
    );
};

export default CategorySelectionScreen;